var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#17508f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114175"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1444d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c53840"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.38095238 1.9047619c0-.51338825.28482201-1.53552264.28482201-1.53552264.05309134-.20392521.26051331-.36923926.47356959-.36923926h1.53083584c.20845393 0 .42113931.16313689.4735696.36658175 0 0 .28482201 1.01254611.28482201 1.53818015 0 .49140785-.28678435 1.53864566-.28678435 1.53864566-.05200757.20220042-.20441279.49882993-.3475127.64982146 0 0-.3180839.47819955-.88951248.47819955-.57142857 0-.88951247-.47819955-.88951247-.47819955-.1399184-.15668606-.29704475-.44915723-.34947504-.65505702 0 0-.28482201-1.02975646-.28482201-1.5334101z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.38095238 1.9047619c0-.51338825.28482201-1.53552264.28482201-1.53552264.05309134-.20392521.26051331-.36923926.47356959-.36923926h1.53083584c.20845393 0 .42113931.16313689.4735696.36658175 0 0 .28482201 1.01254611.28482201 1.53818015 0 .49140785-.28678435 1.53864566-.28678435 1.53864566-.05200757.20220042-.20441279.49882993-.3475127.64982146 0 0-.3180839.47819955-.88951248.47819955-.57142857 0-.88951247-.47819955-.88951247-.47819955-.1399184-.15668606-.29704475-.44915723-.34947504-.65505702 0 0-.28482201-1.02975646-.28482201-1.5334101z",
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 3.809524h16v3.809524h-16z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v3.809524h-16z",
    fill: "url(#d)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 7.619048h16v3.809524h-16z",
    fill: "url(#a)",
    mask: "url(#e)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(3.047619 3.809524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.38095238 1.9047619c0-.51338825.28482201-1.53552264.28482201-1.53552264.05309134-.20392521.26051331-.36923926.47356959-.36923926h1.53083584c.20845393 0 .42113931.16313689.4735696.36658175 0 0 .28482201 1.01254611.28482201 1.53818015 0 .49140785-.28678435 1.53864566-.28678435 1.53864566-.05200757.20220042-.20441279.49882993-.3475127.64982146 0 0-.3180839.47819955-.88951248.47819955-.57142857 0-.88951247-.47819955-.88951247-.47819955-.1399184-.15668606-.29704475-.44915723-.34947504-.65505702 0 0-.28482201-1.02975646-.28482201-1.5334101z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#c43840"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.36907666-.15450052-3.52357718 4.40447148.59494767.47595813 3.52357718-4.40447148z",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-.15450052.32145761 3.52357718 4.40447148.59494767-.47595813-3.52357718-4.40447148z",
    mask: "url(#g)"
  })))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.952381,
    cy: 5.714286,
    fill: "#fff",
    fillRule: "nonzero",
    mask: "url(#e)",
    rx: 1,
    ry: 1.142857
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.80952381 3.04761905-.38095238-.76190476.76190476.38095238.76190476-.38095238.76190476.38095238.76190477-.38095238-.38095238.76190476v.38095238c0 .21039419-.16438294.38095238-.37743923.38095238h-1.53083584c-.20845393 0-.37743922-.17671131-.37743922-.38095238z",
    fill: "#d1a43a",
    fillRule: "nonzero",
    mask: "url(#e)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRs);
export default __webpack_public_path__ + "static/media/RS.dd389797840080fec7c28488102ce0b1.svg";
export { ForwardRef as ReactComponent };